import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import React from 'react';
import { getFleetLocateMediaPath } from './fleetLocateMedia';

const resolveImageUrl = (picSource) => {
  if (!picSource) {
    return '';
  }
  if (picSource.startsWith('http://') || picSource.startsWith('https://')) {
    return picSource;
  }
  return getFleetLocateMediaPath(picSource);
};

const FleetLocateMarketingPanel = ({ slide, Styled }) => {
  if (!slide) {
    return null;
  }

  const imageUrl = resolveImageUrl(slide.picSource);
  const imageAlt = slide.imageAlt || slide.title || 'FleetLocate marketing banner';

  return (
    <Styled.MarketingPageBox>
      <Styled.MarketingContainer>
        <Styled.MarketingImageWrapper>
          <img className="marketing-card-image" src={imageUrl} alt={imageAlt} />
        </Styled.MarketingImageWrapper>

        <Typography
          component="h4"
          variant="h4"
          gutterBottom
          className="marketing-heading"
        >
          {slide.title}
        </Typography>

        <Typography component="p" variant="body1" className="marketing-description">
          {slide.content}
        </Typography>

        {slide.getResourceLink && (
          <Styled.MarketingButtonContainer>
            <Button
              component="a"
              href={slide.getResourceLink}
              target="_blank"
              rel="noopener noreferrer"
              variant="contained"
              disableElevation
              className="marketing-button"
            >
              See For Yourself
            </Button>
          </Styled.MarketingButtonContainer>
        )}
      </Styled.MarketingContainer>
    </Styled.MarketingPageBox>
  );
};

FleetLocateMarketingPanel.propTypes = {
  slide: PropTypes.shape({
    picSource: PropTypes.string,
    title: PropTypes.string,
    content: PropTypes.string,
    getResourceLink: PropTypes.string,
    imageAlt: PropTypes.string,
  }).isRequired,
  Styled: PropTypes.object.isRequired,
};

export default FleetLocateMarketingPanel;
